import { useState } from 'react';
import { Button } from '@shared/components/Button';
import { View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import { QRCode } from './QRCode';

interface Props {
  url: string;
  onCopyQr(data: string): void;
  onCopyLink(uri: string): void;
}

export function ShareQRCodeSection({ url, onCopyLink }: Props) {
  const [showSuccessButton, setShowSuccessButton] = useState(false);

  const copyLinkClicked = () => {
    onCopyLink(url);
    setShowSuccessButton(true);
    setTimeout(() => {
      setShowSuccessButton(false);
    }, 2000);
  };

  const icon = showSuccessButton ? 'check-filled' : 'link';
  const label = showSuccessButton ? i18n('qrCode.share.linkCopied') : i18n('qrCode.share.copyLink');

  return (
    <View gap={1} paddingHorizontal={2}>
      <View center>
        <QRCode size={{ width: 160 }} url={url} />
      </View>
      <Button
        variant="tertiary"
        size="large"
        icon={icon}
        iconGridSize={3.5}
        label={label}
        onClick={copyLinkClicked}
        engaged={showSuccessButton}
        disabled={showSuccessButton}
      />
    </View>
  );
}
